import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default {
    init() {
        let table_info_buttons = document.getElementsByClassName('table-info');
        let modal = document.getElementById('table-modal');

        if(document.body.classList.contains('page-id-668') && modal) {
            disablePageScroll();
        }

        if(table_info_buttons) {
            for(let i = 0; i < table_info_buttons.length; i++) {
                let table_info_button = table_info_buttons[i];
                table_info_button.addEventListener('click', (e) => {
                    let value = e.target.value;
                    if(modal) {
                        modal.classList.add('active');
                        disablePageScroll();
                        let el = modal.querySelector('#table-modal .info-text p');
                        el.innerHTML = value;
                    }
                })
            }
        }

        if(modal) {
            let exit = modal.querySelector('.modal-close');
            exit.addEventListener('click', (e) => {
                modal.classList.remove('active');
                enablePageScroll();
            })

            modal.addEventListener('click', (e) => {
                e.stopPropagation();
                if(e.target === modal) {
                    modal.classList.remove('active');
                    enablePageScroll();
                }
            })
        }
    }
}